class NewSorting extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.sortingItems = this.querySelectorAll("[data-value]");

        this.addEventListener("click", (e) => {
            if (e.target.closest("[data-value]:not(.active)")) {
                e.preventDefault();
                this.onValueChanged(e);
            }
        })
    }

    extractSectionId(element) {
        element = element.classList.contains("shopify-section") ? element : element.closest(".shopify-section");
        return element.id.replace("shopify-section-", "");
    }

    setActiveSortOptionElement(activeSortValue) {
        if (this.sortingItems && this.sortingItems.length > 0) {
            [...this.sortingItems].map(item => {
                if (item.dataset.value !== activeSortValue) {
                    item.classList.remove("active");
                } else {
                    item.classList.add("active");
                }
            })
        }
    }

    onValueChanged(event) {
        const url = new URL(location.href);
        const sectionId = this.extractSectionId(event.target.closest(".shopify-section"));

        url.searchParams.set("sort_by", event.target.href.split("?sort_by=")[1]);
        url.searchParams.set("section_id", sectionId);
        url.searchParams.delete("page");

        this.setActiveSortOptionElement(event.target.href.split("?sort_by=")[1]);
        this.sortApplied(url);
    }

    async fetchWithCache(url) {
        const cacheKey = url;
        const cachedMap = new Map();
    
        if (!document.documentElement.classList.contains("shopify-design-mode")) {
            if (cachedMap.has(cacheKey)) {
                return await (await Promise.resolve(new Response(new Blob([cachedMap.get(cacheKey)])))).text();
            }
        }
    
        return fetch(url).then((response) => {
            if (response.status === 200) {
                response.clone().text().then((content) => {
                    cachedMap.set(cacheKey, content);
                });
                return response.text();
            } else {
                return false;
            }
        });
    }
    
    async sortApplied(url) {
        const shopifySection = document.getElementById(`shopify-section-${url.searchParams.get("section_id")}`);
        const collectionBody = shopifySection.querySelector("[data-new-collection-grid]");
        const clonedUrl = new URL(url);

        clonedUrl.searchParams.delete("section_id");
        history.replaceState({}, "", clonedUrl.toString());
    
        const sectionResponse = await this.fetchWithCache(url.toString());
    
        if (!sectionResponse) {
            console.error("Something went wrong...");
            return;
        }
    
        const tempContent = new DOMParser().parseFromString(sectionResponse, "text/html");
        const tempCollectionContent = tempContent.querySelector("[data-new-collection-grid]");
    
        collectionBody.replaceChildren(...document.importNode(tempCollectionContent, true).childNodes);
    }
}

if (!window.customElements.get("new-sorting")) {
    window.customElements.define("new-sorting", NewSorting);
}